import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export const enum fulfillmentMethodShape {
    circle = "circle",
    rectangle = "rectangle",
}

export const fulfillmentMethodRadioWrapperBaseStyles = (shape: string) => {
    const baseStyle = css`
        padding: 10px;
    `;

    switch (shape) {
        case "circle":
            return css`
                ${baseStyle}
                border-radius: 50%;
            `;
        case "rectangle":
            return css`
                ${baseStyle}
                border-radius: 10px;
            `;
        default:
            return null;
    }
};


export const fulfillmentMethodRadioWrapperUnselectedStyles = () => {
    return css`
        border: 2px solid ${getColor("common.disabledLight")};
    `
};

export const fulfillmentMethodRadioWrapperSelectedStyles = () => {
    return css`
        border: 2px solid ${getColor("primary")};
        background-color: ${getColor("primary.lighter")};
    `
};
